import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import VueCodemirror from 'vue-codemirror';
import store from './store';


import "./assets/reset.css";
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/monokai.css';

Vue.use(VueCodemirror, /* {
  options: { theme: 'base16-dark', ... },
  events: ['scroll', ...]
} */);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
